export const loadMetaPixel = () => {
  // Only load Meta Pixel in production
  var clientDomain = process.env.REACT_APP_CLIENT_DOMAIN;
  var isProduction = clientDomain && clientDomain.includes("www.plaintr.com");

  if (!isProduction || window.fbq) return;

  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod
        ? n.callMethod.apply(n, arguments)
        : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

  window.fbq("init", "1506311913795976");
  window.fbq("track", "PageView");
};
